import { useQuery } from "@tanstack/react-query";
import { reportService } from "../services/reportService";

export const useLoadSubjectStats = (userId, level, subject, medium) => {
  return useQuery({
    queryKey: ["getReportStat", userId, level, subject, medium],
    queryFn: () => reportService.loadSubjectStats(userId, level, subject, medium),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: false,
  });
};

export const useReportCardSubjectProblemsData = (userId, level, subject, medium) => {
  return useQuery({
    queryKey: ["getReportCardSubjectProblemList", userId, level, subject, medium],
    queryFn: () => reportService.getReportCardSubjectProblemList(userId, level, subject, medium),
    staleTime: Infinity,
    cacheTime: Infinity,
    select: (data) => ({
      subjectProblemList: data,
      chapterKeys: Object.keys(data),
    }),
    enabled: !!(userId && level && subject && medium),
  });
};

export const useSectionConceptSummaryReports = (userId, level, subject, medium, chapter, section) => {
  return useQuery({
    queryKey: ["getSectionConceptSummaryReports", userId, level, subject, medium, chapter, section],
    queryFn: () => reportService.getSectionConceptSummaryReports(userId, level, subject, medium, chapter, section),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: false,
  });
};

export const useReportCardData = (userId, level, subject, medium) => {
  return useQuery({
    queryKey: ["reportCardData", userId, level, subject, medium],
    queryFn: () => reportService.loadSubjectStats(userId, level, subject, medium),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!(userId && level && subject && medium),
    select: (data) => {
      // Transform the data if needed
      return {
        correctAnswers: data?.[1] || 0,
        totalQuestions: data?.[0] || 0,
        percentage: data?.[2] || 0,
        rawData: data,
      };
    },
  });
};
